import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BatchService } from '../../../modules/batch/service/batch.service';
import { NotificationService } from '../../../core/services/notification.service';
import { SaleOrderStatus } from '../../../../app/shared/enums/sale-order-status.enum';

@Component({
  selector: 'eci-add-to-existing-batch',
  templateUrl: './add-to-existing-batch.component.html',
  styleUrls: ['./add-to-existing-batch.component.scss']
})

export class AddToExistingBatchComponent implements OnInit {
  theSelectedSaleOrders: any;
  batchList: any[] = [];
  searchBatch: FormControl = new FormControl('');
  showLoader = false;
  
  batchForm!: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<AddToExistingBatchComponent>,
    private formBuilder: FormBuilder,
    private batchService: BatchService,
    private notify: NotificationService,

  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.getListOfBatch();
  }

  initializeForm() {
    this.batchForm = this.formBuilder.group({
      batch: ['', Validators.required] // Ensure it's inside formGroup
    });
  }

  onClickSave(): void {
    this.showLoader = true;
        const saleOrders = this.theSelectedSaleOrders;
        const theSelectedSaleOrderIds = saleOrders.map((so) => so.id);
        if (
            !!saleOrders.find(
                (el) =>
                    el.consolNumber !== null &&
                    el.consolNumber !== undefined
            )
        ) {
            this.notify.showError(
                'Selected items contain sale order which included to Consol Shipment'
            );
            this.dialogRef.close();
            this.showLoader = false;
            return;
        }
    
        if (
            !!saleOrders.find(
                (el) =>
                    el.status === SaleOrderStatus.NEW            
            ) && !!saleOrders.find(
                (el) =>
                    el.status !== SaleOrderStatus.NEW            
            )
        ) {
            this.notify.showError(
                'Selected items contain sale order which do not have NEW status'
            );
            this.dialogRef.close();
            this.showLoader = false;
            return;
        }
    
        if (this.batchForm.valid) {
          const body = {
            'saleOrderIds' : theSelectedSaleOrderIds,
            'batchId' : this.batchForm.value.batch
          }
          this.batchService.updateBatch(body).subscribe((res: any) => {
              this.showLoader = false;
              this.dialogRef.close(res);
          }, error => {
            this.showLoader = false;
            this.notify.showError(error.error ? error.error?.message : 'Something wrong');
            this.dialogRef.close();
          });
        } else {
          this.batchForm.markAllAsTouched();
        }
  }

  onClickClose(): void {
    this.dialogRef.close();
  }

  getListOfBatch(): void {
    this.batchService.getBatchIdList().subscribe({
      next: (result) => {
        if (Array.isArray(result)) {
          this.batchList = result;
        } else {
          console.error('Invalid response format:', result);
        }
      },
      error: (err) => {
        console.error('Error fetching batch IDs:', err);
      }
    });
  }
}

